/**
 * index.html 在 React 启动前完成 WebP 探测，并给 <html> 添加 webp/no-webp 类。
 * 这里把检测结果转换成布尔值，供图片 URL 选择逻辑统一使用。
 */
export const supportsWebp = document.documentElement.classList.contains('webp');
